import { provideHttpClient, withXhr } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideAuth0 } from '@auth0/auth0-angular';
import { provideRichTextConfig } from '@classi/training-ui';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { provideApolloClient } from './core/apollo';
import { getAuth0Config } from './core/auth0';
import {
  provideGoogleAnalyticsTracker,
  provideGoogleAnalyticsUserBinding,
} from './core/ga';
import { httpClientConfig } from './core/http';
import { provideMaterialDefaults } from './core/material';
import { provideSentryAdapter } from './core/sentry';
import { provideTitleStrategy } from './core/title-strategy';

const { kobitoApiEndpoint, auth0 } = environment;

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withXhr(), ...httpClientConfig),
    provideApolloClient({
      // 2つの ApiEndpoint が null である場合は msw が利用され
      // api/mocks/link.ts におけるエンドポイントと同じ値にする必要がある。
      kobitoUri: kobitoApiEndpoint ?? '/kobito/graphql',
    }),
    provideAuth0(getAuth0Config(auth0)),
    provideSentryAdapter(),
    provideTitleStrategy(),
    provideRichTextConfig({
      fallbackOnError: ({ error }) => {
        // リッチテキストのパースエラーが起きたらエラーメッセージを表示する
        console.warn(error);
        return `${error}`;
      },
    }),
    provideMaterialDefaults(),
    provideGoogleAnalyticsTracker(),
    provideGoogleAnalyticsUserBinding(),
  ],
};
